import { createBrowserRouter, Navigate } from "react-router-dom";

import ChooseAccountType from "../../scenes/complete-profile/account-type/ChooseAccountType";
import CompleteProfile from "../../scenes/complete-profile/CompleteProfile";
import SignUpProfileData from "../../scenes/complete-profile/profile-data/CompleteProfileData";
import CompleteProfilePicture from "../../scenes/complete-profile/profile-picture/CompleteProfilePicture";
import CompleteSportsInfo from "../../scenes/complete-profile/sports-info/CompleteSportsInfo";
import ProfileResolver from "../../scenes/profile-page/ProfileResolver";
import TeamPage from "../../scenes/team-page/TeamPage";
import AuthRouteComponent from "./AuthRouteComponent";

const router = createBrowserRouter([
	{
		path: "/",
		element: <AuthRouteComponent />,
		children: [
			{
				index: true,
				element: <Navigate to="/type" />,
			},
			{
				path: "/",
				element: <CompleteProfile />,
				children: [
					{
						path: "type",
						element: <ChooseAccountType />,
					},
					{
						path: "info",
						element: <SignUpProfileData />,
					},
					{
						path: "sports",
						element: <CompleteSportsInfo />,
					},
				],
			},
			{
				path: "pic",
				element: <CompleteProfilePicture />,
			},
			{
				path: "u/:userId",
				element: <ProfileResolver />,
			},
			{
				path: "t/:teamId",
				element: <TeamPage />,
			},
			{
				path: "*",
				element: <Navigate to="/type" />,
			},
		],
	},
]);

export default router;
